import CityPageTemplate from "../city-template/CityPageTemplate";
import { hopewellVaConfig } from "./data";

export default function HopewellVaPage() {
  return <CityPageTemplate config={hopewellVaConfig} />;
}